const TYPE_ID = 0
const TYPE_STRING = 1
const TYPE_BOOL = 2

export default {
  TYPE_ID: TYPE_ID,
  TYPE_STRING: TYPE_STRING,
  TYPE_BOOL: TYPE_BOOL,
}
